import React, { useState } from "react";
import { Upload, Button, message, Image } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useImageUpload } from "../../context/ImageUploadContext";

const ImageUpload = () => {
  const { addImage, clearImages, images } = useImageUpload();

  const handleUpload = ({ file }) => {
    if (file) {
      addImage(file);
      message.success("Rasm tanlandi");
    }
  };

  return (
    <div>
      {images.length === 0 && (
        <Upload
          accept="image/*"
          beforeUpload={() => false}
          showUploadList={false}
          onChange={handleUpload}
        >
          <Button icon={<UploadOutlined />}>Rasm tanlash</Button>
        </Upload>
      )}
      <div className="listImages" style={{ marginTop: 16 }}>
        {images.map((image, index) => (
          <div key={index}>
            <Image
              src={typeof image === 'string' ? image : URL.createObjectURL(image)}
              alt="Preview"
              style={{ maxWidth: 200, maxHeight: 200 }}
            />
            <Button
              style={{ marginTop: 8 }}
              onClick={() => clearImages()}
            >
              O'chirish
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageUpload;